import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INotificationResponse } from '@models/INotification';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {

  private readonly API_URL = environment.API_URL;

  constructor(private http: HttpClient) { }

  getHomeNotifications() {
    return this.http.get<INotificationResponse>(`${this.API_URL}notifications/home`);
  }

  getNotifications() {
    return this.http.get(`${this.API_URL}notifications`);
  }
}
